export default __webpack_public_path__ + "9fdd418e37d080ee7b57d1896a98ac45.svg";